<template>
  <div>
    <el-container>
      <el-aside :width="isCollapse ? '64px' : '300px'" class="h-full bg-gray-500 min-h-screen">
        <!-- <el-radio-group v-model="isCollapse" style="margin-bottom: 20px;">
          <el-radio-button :label="false">展开</el-radio-button>
          <el-radio-button :label="true">收起</el-radio-button>
        </el-radio-group> -->
        <div class="bg-light-500  h-12    flex justify-center items-center" >
          <i v-if="!isCollapse" @click="changeColl" class="el-icon-s-fold" style="color:#fff;font-size: 3rem;"></i>
          <i v-if="isCollapse" @click="changeColl" class="el-icon-s-unfold" style="color:#fff;font-size: 3rem;"></i>
        </div>
        <el-menu
          default-active="1-4-1"
          background-color="#5976ba"
          text-color="#d9d273"
          active-text-color="#fafa61"

          :collapse-transition="false"
          :router="true"
          class="el-menu-vertical-demo "
          @open="handleOpen"
          @close="handleClose"
          :collapse="isCollapse"
        >
          <el-submenu v-for="(item,index) in menu" :index="item.indexs" :key="index">
            <template slot="title">
              <i :class="item.icon" style="color: antiquewhite;"></i>
              <span slot="title">{{ item.title }}</span>
            </template>

            <el-menu-item v-for="(item1,index) in item.children" :index="item1.indexs" :key="index">

              <template slot="title">
              <i :class="item1.icon" style="color: antiquewhite;"></i>
              <span slot="title">{{ item1.title }}</span>
            </template>


            </el-menu-item>

          </el-submenu>


        </el-menu>
      </el-aside>
    </el-container>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isCollapse: false,
      menu: [
        {
          indexs: "news",
          icon: "el-icon-reading",
          title: "文章管理",
          children: [
            {
              indexs: "news",
              icon: "el-icon-document-add",
              title: "文章新增"
            },
            {
              indexs: "newsList",
              icon: "el-icon-document",
              title: "文章列表"
            }
          ]
        },
        {
          indexs: "sidebar",
          icon: "el-icon-picture",
          title: "轮播管理",
          children: [
            {
              indexs: "addSlideshow",
              icon: "el-icon-folder-add",
              title: "轮播新增"
            },
            {
              indexs: "slideshowList",
              icon: "el-icon-tickets",
              title: "轮播列表"
            }
          ]
        },
        {
          indexs: "case",
          icon: "el-icon-notebook-2",
          title: "案例管理",
          children: [
            {
              indexs: "addCase",
              icon: "el-icon-edit-outline",
              title: "案例新增"
            },
            {
              indexs: "caseList",
              icon: "el-icon-receiving",
              title: "案例列表"
            }
          ]
        },

      ]
    };
  },
  methods: {
    changeColl(){
      this.isCollapse = !this.isCollapse;
    },
    handleOpen(key, keyPath) {

    },
    handleClose(key, keyPath) {

    }
  }
};
</script>
<style>
.el-menu{
  border-right: none;
}

</style>



// WEBPACK FOOTER //
// src/layouts/sidebar.vue